const dev = {
    apiDefineUrl: '/dev/define',
    apiHighlightUrl: '/dev/highlight',
    apiWordOfTheDayUrl: '/dev/wordoftheday',
    topTrendingWordsUrl: 'https://fjalorthi-trending-top-words-bucket-dev.s3.eu-central-1.amazonaws.com/top_ga_words.json',
    conjugateVerb: '/dev/conjugateverb',
    apiSearchVerbUrl: '/dev/searchverb',
    gaTrackingCode: 'UA-62542512-4'
};
const prod = {
	apiDefineUrl: '/prod/define',
    apiHighlightUrl: '/prod/highlight',
    apiWordOfTheDayUrl: '/prod/wordoftheday',
    topTrendingWordsUrl: '/prod-trending/top_ga_words.json',
    conjugateVerb: '/prod/conjugateverb',
    apiSearchVerbUrl: '/prod/searchverb',
    gaTrackingCode: 'UA-62542512-4'
};

const config = process.env.REACT_APP_STAGE === 'production'
    ? prod
    : dev;

export default {
    ...config
};
